import { loadPdfBlob, logPdfCacheWarning, } from './pdf-preview-source.js';
/**
 * 渲染 PDF 预览，通过官方预编译的 PDF.js Viewer 加载生成的 Blob URL。
 */
export function renderPdfCanvasPreview(container, request) {
    let disposed = false;
    let blobUrl = null;
    const status = document.createElement('p');
    status.className = 'pdf-canvas-status';
    status.textContent = 'PDF 加载中...';
    container.replaceChildren(status);
    loadPdfBlob(request)
        .then((blob) => {
        if (disposed) {
            return;
        }
        blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.src = `/pdfjs/web/viewer.html?file=${encodeURIComponent(blobUrl)}`;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        iframe.setAttribute('data-testid', 'pdf-preview-iframe');
        container.replaceChildren(iframe);
    })
        .catch((error) => {
        logPdfCacheWarning(error);
        if (disposed) {
            return;
        }
        const fallback = document.createElement('p');
        fallback.className = 'pdf-canvas-fallback';
        const link = document.createElement('a');
        const baseDownloadUrl = `/api/public/materials/${request.materialId}/download`;
        link.href = request.previewToken
            ? `${baseDownloadUrl}?token=${encodeURIComponent(request.previewToken)}`
            : baseDownloadUrl;
        link.className = 'pdf-canvas-fallback';
        link.textContent = `${request.fileName || 'PDF'} 加载失败，点击下载`;
        link.target = '_blank';
        fallback.appendChild(link);
        container.replaceChildren(fallback);
    });
    return {
        dispose: () => {
            disposed = true;
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
                blobUrl = null;
            }
            container.replaceChildren();
        },
    };
}
//# sourceMappingURL=pdf-canvas-renderer.js.map